module.exports = __webpack_public_path__ + "static/media/logo_mastercard.ff03802c.svg";